<template>
    <label class="radio" :for="name" @click="$emit('change',value)">
        <input type="radio" :value="value" :name="name" :checked="checkedValue === value" />
        <i></i>{{text}}
    </label>
</template>

<script>
export default {
    name:'radio-button',
    props:{
        name:{
            type:[String,Number],
            required:true
        },
        value:{
            type:[String,Number,Boolean],
            required:true
        },
        text:{
            type:[String, Number,Boolean],
            required:true
        },
        checkedValue:{
            type:[String,Number,Boolean] 
        }
    },
    model:{
        prop: 'checkedValue',
        event: 'change'
    }
}
</script>
<style lang="less">

</style>


